/* Clean Coffee Pods LP
 * Loaded only on the clean-coffee-pods-lp page/template (see layout/theme.liquid).
 * Every selector below is namespaced to the LP markup, so nothing else on the theme is touched.
 */
(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ================= helpers ================= */

  function fmtMoney(cents, format) {
    var value = (cents || 0) / 100;
    var fmt = format || '£{{amount}}';
    function withDecimals(v, sep, dec) {
      var parts = v.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      return parts.join(dec ? '.' : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount': return withDecimals(value, ',', 2);
        case 'amount_no_decimals': return withDecimals(Math.round(value), ',', 0);
        case 'amount_with_comma_separator': return withDecimals(value, '.', 2).replace(/\.(\d\d)$/, ',$1');
        case 'amount_no_decimals_with_comma_separator': return withDecimals(Math.round(value), '.', 0);
        case 'amount_with_apostrophe_separator': return withDecimals(value, "'", 2);
        case 'amount_with_space_separator': return withDecimals(value, ' ', 2).replace(/\.(\d\d)$/, ',$1');
        case 'amount_no_decimals_with_space_separator': return withDecimals(Math.round(value), ' ', 0);
        case 'amount_with_period_and_space_separator': return withDecimals(value, ' ', 2);
        default: return withDecimals(value, ',', 2);
      }
    });
  }

  function perPod(cents, pods, format) {
    if (!pods) return '';
    var each = Math.round(cents / pods);
    // Sub-unit pricing (e.g. "83p") only makes sense for £-style formats.
    if (each < 100 && /£/.test(format || '')) return each + 'p/pod';
    return fmtMoney(each, format) + '/pod';
  }

  function readJSON(root, selector, fallback) {
    var el = root.querySelector(selector);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
  }

  function list(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  /* ================= offer / buy box ================= */

  function initOffer(root) {
    var moneyFormat = root.getAttribute('data-money-format') || '£{{amount}}';
    var variants = readJSON(root, '[data-ccp-variants]', []);
    if (!variants.length) return;

    var tierData = readJSON(root, '[data-ccp-tiers]', {});
    var giftInfo = readJSON(root, '[data-ccp-gift-data]', {});
    var blendInfo = readJSON(root, '[data-ccp-blend-info]', {});

    var idInput = root.querySelector('[data-ccp-variant-id]');
    var planInput = root.querySelector('[data-ccp-selling-plan]');
    var giftProp = root.querySelector('[data-ccp-gift-property]');
    var volBtns = list(root, '[data-ccp-vol]');
    var blendBtns = list(root, '[data-ccp-blend]');
    var giftEls = list(root, '[data-ccp-gift]');
    var atcText = root.querySelector('[data-ccp-atc-text]');
    var atcBtn = root.querySelector('[data-ccp-atc]');
    var atcTemplate = atcText ? atcText.textContent.trim() : 'ADD TO CART';
    var purchaseBtns = list(root, '[data-ccp-purchase-type]');
    var freqWrap = root.querySelector('[data-ccp-freq]');
    var freqSelect = root.querySelector('[data-ccp-freq-select]');
    var subHint = root.querySelector('[data-ccp-sub-hint]');
    var subPercent = root.querySelector('[data-ccp-sub-percent]');
    var progressFill = root.querySelector('[data-ccp-progress-fill]');
    var progressBar = root.querySelector('[data-ccp-progress-bar]');
    var progressLabel = root.querySelector('[data-ccp-progress-label]');
    var giftFooter = root.querySelector('[data-ccp-gift-footer]');
    var form = root.querySelector('[data-ccp-form]');
    var choiceWrap = root.querySelector('[data-ccp-gift-choice]');
    var choiceInputs = list(root, '[data-ccp-choice-input]');

    var state = {
      opt1: root.getAttribute('data-default-qty') || (volBtns[0] && volBtns[0].getAttribute('data-ccp-vol')),
      opt2: blendBtns.length
        ? blendBtns[0].getAttribute('data-ccp-blend')
        : (root.getAttribute('data-fixed-blend') || ''),
      mode: 'onetime',
      planId: freqSelect ? freqSelect.value : null,
      giftVariants: []
    };

    if (!volBtns.some(function (b) { return b.getAttribute('data-ccp-vol') === state.opt1; })) {
      state.opt1 = volBtns[0] ? volBtns[0].getAttribute('data-ccp-vol') : state.opt1;
    }

    function podsOf(value) {
      var m = String(value || '').match(/\d+/);
      return m ? parseInt(m[0], 10) : 0;
    }

function variantFor(opt1) {
  return variants.filter(function (v) {
    return v.opt1 === opt1 &&
      (!state.opt2 || v.opt2 === state.opt2);
  })[0] || null;}

    function priceFor(variant) {
      if (!variant) return 0;
      if (state.mode === 'subscription' && state.planId && variant.plans && variant.plans[state.planId] != null) {
        return variant.plans[state.planId];
      }
      return variant.price;
    }

    function subPercentOff(variant) {
      if (!variant || !state.planId || !variant.plans || variant.plans[state.planId] == null) return 0;
      return Math.round((1 - variant.plans[state.planId] / variant.price) * 100);
    }

    /* --- gift ladder --- */

    function chosenGiftKey() {
      var checked = choiceInputs.filter(function (i) { return i.checked; })[0];
      return checked ? checked.value : null;
    }

    function renderGifts(pods, tier) {
      var unlockedNames = [];
      var unlockedVariants = [];
      var unlocked = 0;
      var chosen = chosenGiftKey();
      var anyChoiceReached = false;

      // A single flagged gift is not a group — treat it as a normal gift so it can still unlock.
      var choiceEls = choiceInputs.length > 1
        ? giftEls.filter(function (el) { return el.getAttribute('data-choice') === 'true'; })
        : [];
      // The group unlocks at its lowest threshold, so switching your pick never moves the bar.
      var choiceMin = choiceEls.reduce(function (min, el) {
        var n = parseInt(el.getAttribute('data-unlock-pods'), 10) || 0;
        return min === null ? n : Math.min(min, n);
      }, null);

      giftEls.forEach(function (el) {
        var need = parseInt(el.getAttribute('data-unlock-pods'), 10) || 0;
        var isChoice = choiceEls.indexOf(el) !== -1;
        var reached = isChoice ? pods >= choiceMin : pods >= need;
        if (isChoice && reached) anyChoiceReached = true;
        // Within the "choose one" group only the selected gift counts as unlocked.
        var isUnlocked = isChoice
          ? (reached && el.getAttribute('data-ccp-gift') === chosen)
          : reached;
        el.classList.toggle('is-unlocked', isUnlocked);
        el.classList.toggle('is-locked', !isUnlocked);

        var sub = el.querySelector('[data-ccp-gift-sublabel]');
        if (sub) {
          sub.textContent = isUnlocked
            ? sub.getAttribute('data-unlocked')
            : sub.getAttribute('data-locked');
        }
        if (isUnlocked) {
          unlocked++;
          var label = el.querySelector('.ccp-gift__label');
          if (label) unlockedNames.push(label.textContent.trim());
          var vid = (el.getAttribute('data-variant-id') || '').trim();
          if (vid) unlockedVariants.push(vid);
        }
      });

      if (choiceWrap) choiceWrap.hidden = !anyChoiceReached;

      // The choose-one group contributes a single slot to the total, not one per option.
      var choiceOptions = choiceEls.length;
      var total = giftEls.length - (choiceOptions > 1 ? choiceOptions - 1 : 0);
      var pct = total ? Math.round((unlocked / total) * 100) : 0;

      if (progressFill) progressFill.style.width = pct + '%';
      if (progressBar) progressBar.setAttribute('aria-valuenow', String(pct));

      if (progressLabel) {
        var label = tier && tier.progressLabel;
        if (label && choiceOptions > 1 && label.indexOf('[') === -1) {
          // Authored copy hard-codes a gift count that a choose-one group invalidates.
          label = '';
        }
        if (label) {
          label = label.replace('[claimed]', unlocked).replace('[total]', total);
        }
        if (!label) {
          // Fallback wording when a tier has no custom copy.
          label = unlocked >= total
            ? 'Congratulations - ' + unlocked + ' of ' + total + ' free gifts claimed!'
            : unlocked + ' of ' + total + ' free gifts claimed - ' + (total - unlocked) + ' more to go!';
        }
        progressLabel.textContent = label;
        // Urgency colours, matching the reference thresholds.
        progressLabel.classList.remove('is-low', 'is-mid', 'is-high');
        progressLabel.classList.add(pct <= 33 ? 'is-low' : pct <= 66 ? 'is-mid' : 'is-high');
      }

      if (giftFooter) {
        var footer = tier && tier.footerText;
        if (footer) {
          footer = footer.replace('[claimed]', unlocked).replace('[total]', total);
        }
        if (!footer) {
          footer = unlocked >= total
            ? "You've secured all gifts" + (tier && tier.giftValue ? ' worth ' + tier.giftValue : '')
            : 'Upgrade to unlock ' + (total - unlocked) + ' more free gift' + (total - unlocked === 1 ? '' : 's');
        }
        giftFooter.textContent = footer;
      }

      if (giftProp) giftProp.value = unlockedNames.join(', ');
      state.giftVariants = unlockedVariants;
    }

    /* --- render --- */

    function render() {
      var variant = variantFor(state.opt1);
      var pods = podsOf(state.opt1);
      var tier = tierData[String(pods)];

      volBtns.forEach(function (btn) {
        var value = btn.getAttribute('data-ccp-vol');
        var btnPods = parseInt(btn.getAttribute('data-pods'), 10);
        var tv = variantFor(value);
        var isActive = value === state.opt1;

        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');

        if (tv) {
  var tierPrice = priceFor(tv);
  var per = btn.querySelector('[data-ccp-per]');
  var pr = btn.querySelector('[data-ccp-tier-price]');

  if (per) per.textContent = perPod(tierPrice, btnPods, moneyFormat);
  if (pr) pr.textContent = fmtMoney(tierPrice, moneyFormat);

  // Keep quantity selectable even when unavailable.
var isAvailable =
  tv.available === true &&
  tv.inventory_quantity > 0;

btn.disabled = false;
btn.classList.toggle('is-unavailable', !isAvailable);

btn.disabled = false;
btn.classList.toggle('is-unavailable', !isAvailable);
}
      });

      blendBtns.forEach(function (btn) {
        var wrap = btn.closest('.ccp-blend');
        if (wrap) wrap.classList.toggle('is-active', btn.getAttribute('data-ccp-blend') === state.opt2);
      });

      renderGifts(pods, tier);

      var price = priceFor(variant);

 if (variant) {
  if (idInput) idInput.value = variant.id;

  var isSoldOut = variant.available !== true || variant.inventory_quantity <= 0;

  if (atcText) {
    atcText.textContent = isSoldOut
      ? 'SOLD OUT'
      : atcTemplate.replace('[price]', fmtMoney(price, moneyFormat));
  }

  if (atcBtn) {
    atcBtn.disabled = isSoldOut;
    atcBtn.classList.toggle('is-disabled', isSoldOut);
  }

  if (subHint) {
    subHint.textContent = (variant.plans && state.planId && variant.plans[state.planId] != null)
      ? fmtMoney(variant.plans[state.planId], moneyFormat) + '/order'
      : '';
  }

  if (subPercent) {
    var off = subPercentOff(variant);
    subPercent.textContent = off > 0 ? ' ' + off + '%' : '';
  }
}

      if (planInput) {
        if (state.mode === 'subscription' && state.planId) {
          planInput.value = state.planId;
          planInput.disabled = false;
        } else {
          planInput.value = '';
          planInput.disabled = true;
        }
      }

      syncSticky(variant, price);
    }

    /* --- tier / blend / purchase-type events --- */

    // The reference re-defaults the delivery frequency per tier.
    function applyTierFrequency() {
      if (!freqSelect) return;
      var tier = tierData[String(podsOf(state.opt1))];
      if (!tier || !tier.subFreqDays) return;
      var match = list(freqSelect, 'option').filter(function (o) {
        return o.getAttribute('data-days') === String(tier.subFreqDays);
      })[0];
      if (match) {
        freqSelect.value = match.value;
        state.planId = match.value;
      }
    }

    volBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.opt1 = btn.getAttribute('data-ccp-vol');
        applyTierFrequency();
        render();
      });
    });

    blendBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        state.opt2 = btn.getAttribute('data-ccp-blend');
        var info = blendInfo[state.opt2];
        var stickyTitle = document.querySelector('[data-ccp-sticky-title]');
        if (info && info.name && stickyTitle) stickyTitle.textContent = info.name;
        list(document, '[data-ccp-notes-primary]').forEach(function (link) {
          link.setAttribute('data-ccp-notes', state.opt2);
        });
        render();
      });
    });

    purchaseBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.mode = btn.getAttribute('data-ccp-purchase-type');
        purchaseBtns.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        if (freqWrap) freqWrap.hidden = state.mode !== 'subscription';
        root.classList.toggle('is-subscription', state.mode === 'subscription');
        render();
      });
    });

    choiceInputs.forEach(function (input) {
      input.addEventListener('change', render);
    });

    if (freqSelect) {
      freqSelect.addEventListener('change', function () {
        state.planId = freqSelect.value;
        render();
      });
    }

    /* --- add to cart ---
     *
     * Rebuy hooks the add-to-cart *click*, adds the pods itself and opens its drawer. We must not
     * interfere with that: an earlier version re-fired the click after adding the gifts, and Rebuy
     * handled both clicks, so the pods went in twice.
     *
     * So we do nothing to the click at all. We simply add the unlocked gift variants alongside it
     * via /cart/add.js — Shopify's non-AJAX endpoint takes a single line item, hence the AJAX
     * call — then nudge the drawer to re-render so the gifts appear in it. Shopify recalculates
     * discounts on every cart change, so the "buy X get Y" still zeroes them whichever add
     * finishes last. */

    var giftAddInFlight = false;

    function giftLineItems() {
      var items = [];
      (state.giftVariants || []).forEach(function (vid) {
        if (!/^\d+$/.test(vid)) return;
        items.push({
          id: parseInt(vid, 10),
          quantity: 1,
          // Tagged so fulfilment can tell a gift from a bought item. Deliberately NOT
          // _free_gift — the Gift-Guard in Custom.js deletes any line with that flag
          // whenever the coffee starter bundle isn't in the cart.
          properties: { _lp_gift: 'clean-coffee-pods' }
        });
      });
      return items;
    }

function addGifts() {
  if (giftAddInFlight) return;

  var giftItems = giftLineItems();
  if (!giftItems.length) return;

  giftAddInFlight = true;

  var cartRoot = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/')
    .replace(/\/$/, '');

  fetch(cartRoot + '/cart.js', {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' }
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {
      var existingVariantIds = {};

      (cart.items || []).forEach(function (item) {
        existingVariantIds[String(item.variant_id)] = true;
      });

      // Only add gifts that are not already in the cart.
      var itemsToAdd = giftItems.filter(function (gift) {
        return !existingVariantIds[String(gift.id)];
      });

      if (!itemsToAdd.length) return null;

      return fetch(cartRoot + '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({ items: itemsToAdd })
      });
    })
    .catch(function () {
      // A failed gift add must never block the purchase.
    })
    .then(function () {
      giftAddInFlight = false;

      try {
        if (
          window.Rebuy &&
          window.Rebuy.SmartCart &&
          window.Rebuy.SmartCart.render
        ) {
          window.Rebuy.SmartCart.render();
        }
      } catch (err) {}

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', { bubbles: true })
      );
    });
}
function removeOrphanedGifts() {
  if (giftAddInFlight) return;

  var cartRoot = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/')
    .replace(/\/$/, '');

  fetch(cartRoot + '/cart.js', {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' }
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {
      var podVariantIds = {};

      // All variants belonging to the Clean Coffee Pods LP.
      variants.forEach(function (variant) {
        if (variant && variant.id) {
          podVariantIds[String(variant.id)] = true;
        }
      });

      // Check whether the main Clean Coffee Pods product is still in cart.
      var hasPods = (cart.items || []).some(function (item) {
        return podVariantIds[String(item.variant_id)];
      });

      if (hasPods) return null;

      // Find gifts that were added by this LP.
      var giftUpdates = {};

      (cart.items || []).forEach(function (item) {
        var properties = item.properties || {};

        if (properties._lp_gift === 'clean-coffee-pods') {
          giftUpdates[item.key] = 0;
        }
      });

      if (!Object.keys(giftUpdates).length) return null;

      return fetch(cartRoot + '/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          updates: giftUpdates
        })
      });
    })
    .then(function () {
      try {
        if (
          window.Rebuy &&
          window.Rebuy.SmartCart &&
          window.Rebuy.SmartCart.render
        ) {
          window.Rebuy.SmartCart.render();
        }
      } catch (err) {}

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', { bubbles: true })
      );
    })
    .catch(function () {
      // Never block the customer's cart action.
    });
}
    /* Which event to hang this on took two goes to get right:
     *
     *  - form 'submit'  fires reliably. Rebuy calls preventDefault on it, which stops the
     *                   navigation but does NOT stop other submit listeners, so ours still runs.
     *  - button 'click' does NOT reach us. Rebuy's handler runs first and kills the event for
     *                   later listeners, so hanging it here silently added nothing.
     *
     * So: submit, with no preventDefault of our own and nothing re-fired. Rebuy adds the pods and
     * opens the drawer; we add the gifts alongside. The click listener stays as a backstop in case
     * Rebuy ever stops cancelling the submit — addGifts guards itself against running twice. */
if (form) form.addEventListener('submit', addGifts);
if (atcBtn) atcBtn.addEventListener('click', addGifts);

document.addEventListener('cart:refresh', removeOrphanedGifts);
document.addEventListener('cart:updated', removeOrphanedGifts);
    /* --- gift info popup --- */

    list(root, '[data-ccp-gift-info]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        var data = giftInfo[btn.getAttribute('data-ccp-gift-info')];
        if (!data) return;
        var modal = document.getElementById('ccp-gift-modal');
        if (!modal) return;
        var hero = modal.querySelector('[data-ccp-gm-hero]');
        if (hero) hero.style.backgroundImage = data.img ? "url('" + data.img + "')" : 'none';
        setText(modal, '[data-ccp-gm-name]', data.name);
        setText(modal, '[data-ccp-gm-value]', data.value);
        setText(modal, '[data-ccp-gm-desc]', data.desc);
        var ul = modal.querySelector('[data-ccp-gm-benefits]');
        if (ul) {
          var lines = String(data.benefits || '').split(/\r?\n/).filter(function (l) { return l.trim(); });
          ul.innerHTML = '';
          lines.forEach(function (line) {
            var li = document.createElement('li');
            li.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/><path d="M5 8l2 2 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
            var span = document.createElement('span');
            span.textContent = line.trim();
            li.appendChild(span);
            ul.appendChild(li);
          });
        }
        openModal(modal);
      });
    });

    /* --- tasting notes popup --- */

    list(document, '[data-ccp-notes]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var data = blendInfo[btn.getAttribute('data-ccp-notes')];
        var modal = document.getElementById('ccp-notes-modal');
        if (!data || !modal) return;
        var hero = modal.querySelector('[data-ccp-tn-hero]');
        if (hero) hero.style.backgroundImage = data.img ? "url('" + data.img + "')" : 'none';
        var soon = modal.querySelector('[data-ccp-tn-soon]');
        if (soon) soon.hidden = !data.soon;
        setText(modal, '[data-ccp-tn-name]', data.name);
        setText(modal, '[data-ccp-tn-meta]', data.meta);
        setText(modal, '[data-ccp-tn-intro]', data.intro);
        setText(modal, '[data-ccp-tn-origin]', data.origin);
        setText(modal, '[data-ccp-tn-notes]', data.notes);

        var strength = modal.querySelector('[data-ccp-tn-strength]');
        if (strength) {
          strength.innerHTML = '';
          for (var i = 1; i <= 5; i++) {
            var dot = document.createElement('span');
            dot.className = 'ccp-sdot' + (i <= (data.level || 0) ? ' is-on' : ' is-off');
            strength.appendChild(dot);
          }
        }
        var caffRow = modal.querySelector('[data-ccp-tn-caffeine-row]');
        if (caffRow) {
          caffRow.hidden = !data.caffeine;
          setText(modal, '[data-ccp-tn-caffeine]', data.caffeine);
        }
        openModal(modal);
      });
    });

    function setText(scope, selector, value) {
      var el = scope.querySelector(selector);
      if (el) el.textContent = value || '';
    }

    /* --- sticky bars --- */

    var stickyDesktop = document.querySelector('[data-ccp-sticky-desktop]');
    var stickyMobile = document.querySelector('[data-ccp-sticky-mobile]');
    var stickySelect = document.querySelector('[data-ccp-sticky-select]');
    var stickyPrice = document.querySelector('[data-ccp-sticky-price]');
    var stickyAtc = document.querySelector('[data-ccp-sticky-atc]');
    var stickyMobileBtn = document.querySelector('[data-ccp-sticky-mobile-btn]');
    var stickyDesktopTpl = root.getAttribute('data-sticky-desktop-text') || 'ADD TO CART';
    var stickyMobileTpl = root.getAttribute('data-sticky-mobile-text') || 'Get Pods Offer';

    if (stickySelect && !stickySelect.options.length) {
      volBtns.forEach(function (btn) {
        var opt = document.createElement('option');
        opt.value = btn.getAttribute('data-ccp-vol');
        opt.textContent = btn.getAttribute('data-ccp-vol');
        stickySelect.appendChild(opt);
      });
      stickySelect.addEventListener('change', function () {
        state.opt1 = stickySelect.value;
        render();
      });
    }

    function scrollToOffer() {
      var offset = window.innerWidth <= 768 ? 72 : 0;
      window.scrollTo({
        top: root.getBoundingClientRect().top + window.pageYOffset - offset,
        behavior: REDUCED ? 'auto' : 'smooth'
      });
    }
   if (stickyAtc) stickyAtc.addEventListener('click', function () {
  if (atcBtn && !atcBtn.disabled) atcBtn.click();
});
    if (stickyMobileBtn) stickyMobileBtn.addEventListener('click', scrollToOffer);

function syncSticky(variant, price) {
  if (stickySelect && stickySelect.value !== state.opt1) {
    stickySelect.value = state.opt1;
  }

  var money = fmtMoney(price, moneyFormat);

var isSoldOut =
  !variant ||
  variant.available !== true ||
  Number(variant.inventory_quantity || 0) <= 0;

  if (stickyPrice) {
    stickyPrice.textContent = money;
  }

  if (stickyAtc) {
    stickyAtc.textContent = isSoldOut
      ? 'SOLD OUT'
      : stickyDesktopTpl.replace('[price]', money);

    stickyAtc.disabled = isSoldOut;
    stickyAtc.classList.toggle('is-disabled', isSoldOut);
  }

  // if (stickyMobileBtn) {
  //   stickyMobileBtn.textContent = isSoldOut
  //     ? 'SOLD OUT'
  //     : stickyMobileTpl.replace('[price]', money);

  //   stickyMobileBtn.disabled = isSoldOut;
  //   stickyMobileBtn.classList.toggle('is-disabled', isSoldOut);
  // }
}

    if (stickyDesktop || stickyMobile) {
      var hero = document.querySelector('.ccp-hero');
      var onScroll = function () {
        // Desktop bar: once the hero has scrolled by. Mobile bar: once the offer is reached.
        if (stickyDesktop) {
          var heroHeight = hero ? hero.offsetHeight : window.innerHeight;
          stickyDesktop.classList.toggle('is-visible', window.pageYOffset > heroHeight);
        }
        if (stickyMobile) {
          stickyMobile.classList.toggle('is-visible', window.pageYOffset > root.offsetTop - 120);
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();
    }

    applyTierFrequency();
    render();
  }

  /* ================= gallery ================= */

  function initGallery(gallery) {
    var imgs = list(gallery, '.ccp-gallery__img');
    var thumbs = list(gallery, '.ccp-gallery__thumb');
    var arrows = list(gallery, '.ccp-gallery__arrow');
    if (imgs.length < 2) arrows.forEach(function (a) { a.hidden = true; });

    var index = 0;

    function show(i, scrollThumb) {
      index = (i + imgs.length) % imgs.length;
      imgs.forEach(function (img, n) { img.classList.toggle('is-active', n === index); });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === index); });
      if (scrollThumb && thumbs[index]) {
        var active = thumbs[index];
        var strip = active.parentNode;
        // Scroll the thumbnail strip only — never the page.
        strip.scrollLeft = active.offsetLeft - (strip.clientWidth - active.offsetWidth) / 2;
      }
    }

    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n, true); }); });
    var prev = gallery.querySelector('[data-ccp-gallery-prev]');
    var next = gallery.querySelector('[data-ccp-gallery-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1, true); });
    if (next) next.addEventListener('click', function () { show(index + 1, true); });

    // Keyboard + swipe.
    gallery.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') show(index - 1, true);
      if (e.key === 'ArrowRight') show(index + 1, true);
    });
    var startX = null;
    var main = gallery.querySelector('.ccp-gallery__main');
    if (main) {
      main.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) show(index + (dx < 0 ? 1 : -1), true);
        startX = null;
      }, { passive: true });
    }

    show(0);
  }

  /* ================= accordions (single-open, like the reference) ================= */

  function initAccordions(scope) {
    var items = list(scope, '.ccp-acc__item');
    items.forEach(function (item) {
      var q = item.querySelector('.ccp-acc__q');
      var a = item.querySelector('.ccp-acc__a');
      if (!q || !a) return;
      q.addEventListener('click', function () {
        var wasOpen = item.classList.contains('is-open');
        items.forEach(function (other) {
          other.classList.remove('is-open');
          var oq = other.querySelector('.ccp-acc__q');
          var oa = other.querySelector('.ccp-acc__a');
          if (oq) oq.setAttribute('aria-expanded', 'false');
          if (oa) oa.style.maxHeight = '0px';
        });
        if (!wasOpen) {
          item.classList.add('is-open');
          q.setAttribute('aria-expanded', 'true');
          a.style.maxHeight = a.scrollHeight + 'px';
        }
      });
    });
  }

  /* ================= modals ================= */

  var lastFocus = null;

  function openModal(modal) {
    lastFocus = document.activeElement;
    if (modal._ccpTimer) { clearTimeout(modal._ccpTimer); modal._ccpTimer = null; }
    modal.hidden = false;
    // Force a frame so the enter transition runs.
    requestAnimationFrame(function () { modal.classList.add('is-open'); });
    document.documentElement.classList.add('ccp-modal-open');
    var close = modal.querySelector('[data-ccp-close]');
    if (close) close.focus();
  }

  function closeModal(modal) {
    modal.classList.remove('is-open');
    var done = function () { modal.hidden = true; modal._ccpTimer = null; };
    if (modal._ccpTimer) clearTimeout(modal._ccpTimer);
    if (REDUCED) done();
    else modal._ccpTimer = setTimeout(done, 200);
    document.documentElement.classList.remove('ccp-modal-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function initModals() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-ccp-open]');
      if (opener) {
        e.preventDefault();
        var modal = document.getElementById(opener.getAttribute('data-ccp-open'));
        if (modal) openModal(modal);
        return;
      }
      if (e.target.closest('[data-ccp-close]') || (e.target.hasAttribute && e.target.hasAttribute('data-ccp-modal'))) {
        var open = document.querySelector('[data-ccp-modal].is-open');
        if (open) closeModal(open);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = document.querySelector('[data-ccp-modal].is-open');
      if (open) closeModal(open);
    });
  }

  /* ================= count-up (reused clean-energy-results section) ================= */

  function initCountUp() {
    var section = document.querySelector('.new-clean');
    if (!section) return;
    var nodes = list(section, '.clean-energy__percent');
    if (!nodes.length) return;

    var parsed = nodes.map(function (node) {
      var raw = String(node.textContent).trim();
      var m = raw.match(/(\d+)/);
      if (!m) return null;
      return {
        node: node,
        target: parseInt(m[1], 10),
        prefix: raw.slice(0, m.index),
        suffix: raw.slice(m.index + m[1].length)
      };
    }).filter(Boolean);

    if (!parsed.length) return;

    if (REDUCED || !('IntersectionObserver' in window)) return;

    parsed.forEach(function (p) { p.node.textContent = p.prefix + '0' + p.suffix; });

    var done = false;
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting || done) return;
      done = true;
      io.disconnect();
      var duration = 1400;
      var start = performance.now();
      function tick(now) {
        var progress = Math.min((now - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        parsed.forEach(function (p) {
          p.node.textContent = p.prefix + Math.round(eased * p.target) + p.suffix;
        });
        if (progress < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }, { threshold: 0.3 });
    io.observe(section);
  }

  /* ================= reveal on scroll ================= */

  // Sections reused from the theme can't carry a class of their own, so tag them here.
  var REVEAL_TARGETS = [
    '.shopify-section--press',
    '.ccp-iwt',
    '.ccp-pcards',
    '.new-clean',
    '#New-Custom-Reviews',
    '#ccp-revhead',
    '#experts-trusted',
    '#new-faq-lp',
    '.shopify-section--rich-text .content-box',
    '.ccp-auth',
    '.ccp-comp'
  ];

  function initReveal() {
    REVEAL_TARGETS.forEach(function (sel) {
      list(document, sel).forEach(function (el) { el.classList.add('ccp-reveal'); });
    });

    if (REDUCED || !('IntersectionObserver' in window)) {
      list(document, '.ccp-reveal').forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }

    // Only arm the hidden state once JS is running, so a script failure never blanks the page.
    document.body.classList.add('ccp-anim-ready');

    var targets = list(document, '.ccp-reveal');
    if (!targets.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    targets.forEach(function (t) { io.observe(t); });
  }

  /* ================= press quote cross-fade ================= */

  function initPressFade() {
    var pressSection = document.querySelector('.shopify-section--press');
    if (!pressSection) return;
    var buttons = list(pressSection, '.press-list__logo-item');
    var items = list(pressSection, '.press-list__item-content');
    if (!buttons.length || !items.length) return;
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        items.forEach(function (item) {
          item.classList.remove('ccp-quote-in');
          // Restart the fade on whichever quote the theme just revealed.
          requestAnimationFrame(function () { item.classList.add('ccp-quote-in'); });
        });
      });
    });
  }

  /* ================= smooth in-page scrolling ================= */

  function initSmoothScroll() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a) return;
      var href = a.getAttribute('href');
      if (!href || href === '#') return;
      var target;
      try { target = document.querySelector(href); } catch (err) { return; }
      if (!target) return;
      e.preventDefault();
      var offset = window.innerWidth <= 768 ? 72 : 0;
      window.scrollTo({
        top: target.getBoundingClientRect().top + window.pageYOffset - offset,
        behavior: REDUCED ? 'auto' : 'smooth'
      });
    });
  }

  /* ================= reveal the review photos the theme section hides ================= */

  function unhideReviewPhotos() {
    list(document, '#New-Custom-Reviews .review-image img[hidden]').forEach(function (img) {
      img.removeAttribute('hidden');
    });
  }

  /* ================= boot ================= */

  var globalsBound = false;

  function boot() {
    var offer = document.querySelector('[data-ccp-offer]');
    if (offer) {
      var gallery = offer.querySelector('[data-ccp-gallery]');
      if (gallery) initGallery(gallery);
      initAccordions(offer);
      initOffer(offer);
    }
    initCountUp();
    initReveal();
    initPressFade();
    unhideReviewPhotos();

    // Document-level listeners must only ever be attached once.
    if (!globalsBound) {
      globalsBound = true;
      initModals();
      initSmoothScroll();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor re-renders a section's markup; re-wire whatever came back.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && !e.target.querySelector('[data-ccp-offer], .ccp-reveal, .clean-energy__percent')) return;
    boot();
  });
})();

// ---- 

function updateStickyMobilePrice() {
  const stickyBtn = document.querySelector('[data-ccp-sticky-mobile-btn]');
  const activeVol = document.querySelector('[data-ccp-vols] .ccp-vol.is-active');

  if (!stickyBtn || !activeVol) return;

  const price = activeVol.querySelector('[data-ccp-tier-price]')?.textContent.trim();

  if (price) {
    stickyBtn.dataset.price = price;
  }
}

document.addEventListener('DOMContentLoaded', function () {
  updateStickyMobilePrice();

  document.querySelectorAll('[data-ccp-vol]').forEach(button => {
    button.addEventListener('click', function () {
      setTimeout(updateStickyMobilePrice, 50);
    });
  });
});